module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.alwaysShow ? true : (_vm.pageLinks && _vm.pageLinks.length > 1)) ? _c('div', {
    staticClass: "p-paginator p-component"
  }, [(_vm.$scopedSlots.left) ? _c('div', {
    staticClass: "p-paginator-left-content"
  }, [_vm._t("left", null, {
    "state": _vm.currentState
  })], 2) : _vm._e(), _vm._v(" "), _vm._l((_vm.templateItems), function(item) {
    return [(item === 'FirstPageLink') ? _c('FirstPageLink', {
      key: item,
      attrs: {
        "disabled": _vm.isFirstPage
      },
      on: {
        "click": function($event) {
          return _vm.changePageToFirst($event)
        }
      }
    }) : (item === 'PrevPageLink') ? _c('PrevPageLink', {
      key: item,
      attrs: {
        "disabled": _vm.isFirstPage
      },
      on: {
        "click": function($event) {
          return _vm.changePageToPrev($event)
        }
      }
    }) : (item === 'NextPageLink') ? _c('NextPageLink', {
      key: item,
      attrs: {
        "disabled": _vm.isLastPage
      },
      on: {
        "click": function($event) {
          return _vm.changePageToNext($event)
        }
      }
    }) : (item === 'LastPageLink') ? _c('LastPageLink', {
      key: item,
      attrs: {
        "disabled": _vm.isLastPage
      },
      on: {
        "click": function($event) {
          return _vm.changePageToLast($event)
        }
      }
    }) : (item === 'PageLinks') ? _c('PageLinks', {
      key: item,
      attrs: {
        "value": _vm.pageLinks,
        "page": _vm.page
      },
      on: {
        "click": function($event) {
          return _vm.changePageLink($event)
        }
      }
    }) : (item === 'CurrentPageReport') ? _c('CurrentPageReport', {
      key: item,
      attrs: {
        "template": _vm.currentPageReportTemplate,
        "page": _vm.page,
        "pageCount": _vm.pageCount,
        "first": _vm.d_first,
        "rows": _vm.d_rows,
        "totalRecords": _vm.totalRecords
      }
    }) : (item === 'RowsPerPageDropdown' && _vm.rowsPerPageOptions) ? _c('RowsPerPageDropdown', {
      key: item,
      attrs: {
        "rows": _vm.d_rows,
        "options": _vm.rowsPerPageOptions
      },
      on: {
        "rows-change": function($event) {
          return _vm.onRowChange($event)
        }
      }
    }) : _vm._e()]
  }), _vm._v(" "), (_vm.$scopedSlots.right) ? _c('div', {
    staticClass: "p-paginator-right-content"
  }, [_vm._t("right", null, {
    "state": _vm.currentState
  })], 2) : _vm._e()], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47d8e371"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/primevue/paginator/Paginator.vue
// module id = 2202
// module chunks = 0